import { Injectable, Inject } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from './shared/services/logging/logging.service';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VersionService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    private uri = `${environment.apiLocation}/Version`;

    public getVersion(): Observable<string> {
        try {
            return this.http.get<string>(this.uri).pipe(res => {
                this.log.verbose({
                    type: 'VersionService:getVersion:reponse',
                    res
                });
                return res;
            });
        } catch (e) {
            this.log.warn({
                type: 'VersionService:getVersion',
                e
            });
            return of[''];
        }
    }
}
